import { Controller } from '@hotwired/stimulus';
import markerUrl from '../../images/pin.png';

export default class extends Controller {
  connect() {
    this.loadMap();
  }

  async loadMap() {
    const mapboxId = document.querySelector('meta[name="global_mapbox_id"]')?.content;
    const mapboxToken = document.querySelector('meta[name="global_mapbox_token"]')?.content;

    if (!mapboxId && !mapboxToken) {
      console.info('No mapbox id or token found');
      return;
    }

    const Leaflet = await import('leaflet/dist/leaflet.js');

    let config = JSON.parse(this.element.dataset.leaflet || 'null');
    config = Object.assign({
      center: [55.688760, 21.153187],
      zoom: 4,
      scrollWheelZoom: false,
      attributionControl: false,
      zoomControl: false,
    }, config);

    const map = Leaflet.map(this.element, config);

    // DEBUG OR MARKER COORD HELPER:
    // window.map = map;
    //
    // map.on('click', function (ev) {
    //   console.log(ev.latlng);
    // });

    Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: '',
      id: mapboxId,
      tileSize: 512,
      zoomOffset: -1,
      accessToken: mapboxToken,
    }).addTo(map);

    (config.markers || []).forEach(marker => {
      Leaflet.marker([marker.lat, marker.lng], {
        icon: new (Leaflet.Icon.extend({
          options: {
            iconSize: [32, 41],
            iconAnchor: [16, 41],
          },
        }))({ iconUrl: markerUrl }),
      }).addTo(map);
    });
  }
}
